// extracted by mini-css-extract-plugin
module.exports = {"text":"verify_lawyer_modal_validated-module__text--3aEyf","button":"verify_lawyer_modal_validated-module__button--zcjW9"};